import axios from "./http";

let baseUrl = "";

export function getProductList(params) {
  return axios.post(`${baseUrl}/syapi/goods/lists`, params);
}
//登录
export function login(params) {
  return axios.post(`${baseUrl}/syapi/cashier/login`, params);
}
//获取商品所有分类
export function allCategory(params) {
  return axios.post(`${baseUrl}/syapi/category/lists`, params);
}
//添加商品分类
export function addCategory(params) {
  return axios.post(`${baseUrl}/syapi/category/add`, params);
}
//获取订单列表
export function getOrderList(params) {
  return axios.post(`${baseUrl}/syapi/order/lists`, params);
}
//获取当前分类下的商品
export function getCategoryGoods(params) {
  return axios.post(`${baseUrl}/syapi/goods/lists`, params);
}
//查询会员信息
export function getMemberInfo(params) {
  return axios.post(`${baseUrl}/syapi/member/searchemember`, params);
}
// 删除商品分类
export function getdelInfo(params) {
  return axios.post(`${baseUrl}/syapi/category/del`, params);
}
// 编辑商品分类
export function getedcategoryInfo(params) {
  return axios.post(`${baseUrl}/syapi/category/edcategory`, params);
}
//删除商品
export function delGoods(params) {
  return axios.post(`${baseUrl}/syapi/goods/del`, params);
}
//添加商品
export function addGoods(params) {
  return axios.post(`${baseUrl}/syapi/goods/add`, params);
}
//获取商品规格项
export function getGoodsSpec(params) {
  return axios.get(`${baseUrl}/syapi/goods/goodsspec`, params);
}

// 编辑商品保存
export function updateGoodsInfo(params) {
  return axios.post(`${baseUrl}/syapi/goods/editsave`, params);
}

// 修改商品分类
export function updateGoodsType(params) {
  return axios.post(`${baseUrl}/syapi/goods/edcategory`, params);
}
//修改商品分类
export function changeCategray(params) {
  return axios.post(`${baseUrl}/syapi/category/ed`, params);
}
//获取订单详情
export function getOrderDetail(params) {
  return axios.get(`${baseUrl}/syapi/order/detail/?id=${params}`);
}
//订单退款
export function refund(params) {
  return axios.post(`${baseUrl}/syapi/order/refund`, params);
}

// 批量修改售价
export function updateGoodsPrice(params) {
  return axios.post(`${baseUrl}/syapi/goods/edprice`, params);
}

// 请求规格项
export function getGoodsSpecItem(params) {
  return axios.post(`${baseUrl}/syapi/goods/goodsspecitem`, params);
}
//结算接口
export function orderPay(params) {
  return axios.post(`${baseUrl}/syapi/order/settle`, params);
}

//查询扫描枪的接口
export function saomaFind(params) {
  return axios.post(`${baseUrl}/syapi/goods/scansearch`, params);
}
//轮询接口
export function getPayResult(params) {
  return axios.post(`${baseUrl}/syapi/order/query`, params);
}

//支付

export function payMoney(params) {
  return axios.post(`${baseUrl}/syapi/order/pay`, params);
}
//获取发票

export function getFaPiao(params) {
  return axios.post(`${baseUrl}/syapi/order/fapiao`, params);
}

//发送验证码
export function goSendCode(params) {
  return axios.post(`${baseUrl}/syapi/sms/sendcaptcha`, params);
}
// 获取主题颜色 收款按钮背景色 主题字体颜色
export function getColorConfig() {
  return axios({
    url: `${baseUrl}/syapi/config/color`,
    method: "get"
  });
}
//获取语音
export function getAudio(params) {
  return axios.get(`${baseUrl}/syapi/config/textVoice`, params);
}
//获取第二轮播
export function getmadt(params) {
  return axios.get(`${baseUrl}/syapi/config/secondscreenad`, params);
}
//生成一维码
export function getBarcodegena(params) {
  return axios({
    url: `${baseUrl}/syapi/config/Barcodegena`,
    method: "get",
    // responseType:'blob',
    params
  });
}
// 切换商品上架状态
export function updateSaleStatus(params) {
  return axios.get(
    `${baseUrl}/syapi/goods/updateStatus?ids=${params.ids}&status=${params.status}`,
    params
  );
}
// 获取商品信息
export function getGoodsInfo(params) {
  // return axios.get(`${baseUrl}/syapi/goods/getLabel`, params)
  return axios({
    url: `${baseUrl}/syapi/goods/getLabel`,
    method: "get",
    params
  });
}
// 生成商品条形码
export function getCodeTim(params) {
  return axios({
    url: `${baseUrl}/syapi/goods/saveLabel`,
    method: "get",
    // responseType:'blob',
    params
  });
}
// 获取基本配置
export function getBaseConfig(params) {
  return axios({
    url: `${baseUrl}/syapi/config/config`,
    method: "get",
    params
  });
}
//主屏
export function speakST(val, type) {
  // 检查浏览器是否支持Web Speech API
  const synth = window.speechSynthesis;
  // 创建一个新的SpeechSynthesisUtterance对象
  let text = "";
  // 设置要转换为语音的文本
  if (type) {
    if (type == "wechat") {
      text = `微信支付，收款${val}元`;
    } else if (type == "alipay") {
      text = `支付宝支付，收款${val}元`;
    } else {
      text = `${val}`;
    }
  } else {
    text = `收款成功，收款${val}元`;
  }
  // console.log(text)
  if (window.ttsspeaker) {
        window.ttsspeaker(text);
  }else{
            const speech = new SpeechSynthesisUtterance();
            speech.text = text;
            window.speechSynthesis.speak(speech);

  }
  // // 将文本转换为声音
  // axios.get(`${baseUrl}/syapi/config/textVoice?text=${text}&spd=5`, {
  //   responseType: 'blob'
  // }).then((res) => {
  //   // console.log(res)
  //   // const blob = res
  //   // // 处理下载得到的 Blob 对象
  //   // // 创建 AudioContext 对象
  //   // // 将返回的音频数据（res）封装成一个Blob对象
  //   // const audioBlob = new Blob([res], { type: 'audio/mp3' });
  //   // // 创建audio元素
  //   // const audio = new Audio();
  //   // // const audio = document.createElement('audio'); 也可以替代上面的创建元素方法
  //   // // 通过 createObjectURL 方法将 Blob 对象生成一个音频文件 URL
  //   // audio.src = URL.createObjectURL(audioBlob);
  //   // // 在页面中播放音频
  //   // audio.play();
  //   // // 回收对象URL
  //   // URL.revokeObjectURL(audioUrl);

  //   const blob = res;
  //   const audioBlob = new Blob([blob], { type: 'audio/mp3' });
  //   // 将Blob对象转换成URL对象并设置音频元素的src属性
  //   const audioUrl = URL.createObjectURL(audioBlob);
  //   const audio = document.getElementById('myAudio');
  //   audio.src = audioUrl;
  //   // 播放音频
  //   audio.play();
  //   // URL.revokeObjectURL(audioUrl);
  // }).catch(() => {

  // })
}



// WEBPACK FOOTER //
// ./src/api/index.js